import {
    CardActionArea,
    CircularProgress,
    ClickAwayListener,
    Divider,
    Icon,
    Modal, styled,
    SwipeableDrawer, tableRowClasses
} from "@mui/material";
import getLPTheme from '../getLPTheme';
import BottomNavigation from '@mui/material/BottomNavigation';
import Puller from './Puller';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ReorderIcon from '@mui/icons-material/Reorder';
import MapIcon from '@mui/icons-material/Map';
import SpaIcon from '@mui/icons-material/Spa';
import FilterListIcon from '@mui/icons-material/FilterList';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Avatar from '@mui/material/Avatar';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import TableCell from '@mui/material/TableCell';
import { useMediaQuery } from "@mui/material";
import FilterIcon from '../images/filter_icon';
import { useTheme } from "@mui/material";
import TuneIcon from '@mui/icons-material/Tune';
import PlaceIcon from '@mui/icons-material/Place';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Badge from '@mui/material/Badge';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';
import Chip from '@mui/material/Chip';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import dayjs, { Dayjs } from 'dayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Link from '@mui/material/Link';
import {useContext, useEffect, useState, useRef} from 'react';
import {SvgIcon} from "@mui/material";

import {AuthContext} from "../index";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import axios from "axios";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Stack from "@mui/material/Stack";
import {compareDesc} from "date-fns";
import Container from "@mui/material/Container";

import { BSERVICES } from '../data/database';
import { LOCATIONS } from '../data/database';
import {LocalizationProvider, StaticDatePicker} from "@mui/x-date-pickers";
import {grey} from "@mui/material/colors";


const InfoV2 = ({children, open, handleClose, heightPercent = 85, showPuller = true}) =>
{
    return (
        <ClickAwayListener onClickAway={() =>{}}>
            <SwipeableDrawer
                open={ open }
                anchor="bottom"
                onOpen={() => {}}
                onClose={ handleClose }
                ModalProps={{
                    keepMounted: true,
                }}
                PaperProps={{
                    elevation: 0,
                    square: false,
                    sx: {
                        borderTopLeftRadius: '15px',
                        borderTopRightRadius: '15px',
                        overflow: 'visible',
                        height: `calc(${heightPercent}%)`
                    },
                }}
                sx={{ zIndex: 1300 }}
            >
                { showPuller ? <Puller/> : null }
                { children }
            </SwipeableDrawer>
        </ClickAwayListener>
    );
}

export default InfoV2;
